module.exports = __webpack_public_path__ + "static/media/img05.9a5c8dea.png";